// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EE-z","hovered":"FE-z","hoverImage":"GE-z","mainImage":"HE-z","imageNoBackground":"IE-z","fullSizeImage":"JE-z"};